import { useQuery } from '@tanstack/react-query';

import { listGems, type Gem, type LocalizedNullableText } from '../api/gems-api';

export const GEMS_QUERY_KEY = ['gems', 'list'] as const;

// Fetches the visibility-filtered gem catalogue. Gems are near-static, so the
// result is cached generously — every consumer (sidebar, composer, page)
// shares this one query.
export function useGems() {
  return useQuery({
    queryKey: GEMS_QUERY_KEY,
    queryFn: listGems,
    staleTime: 5 * 60_000,
  });
}

// Picks the string for the active language, tolerating a missing translation
// by falling back to the other locale.
export function localizedText(
  value: LocalizedNullableText | { en: string; ar: string },
  lang: string,
): string {
  const preferAr = lang.startsWith('ar');
  const primary = preferAr ? value.ar : value.en;
  const fallback = preferAr ? value.en : value.ar;
  return primary ?? fallback ?? '';
}

/** A gem's display name in the active language. */
export function gemName(gem: Gem, lang: string): string {
  return localizedText(gem.name, lang);
}
